import { useLayoutEffect } from 'react';
/**
 * Хук useLayoutEffect, который не генерирует warning при серверном рендеринге
 * Использует useLayoutEffect на клиенте и пустую функцию на сервере
 *
 * @param effect Эффект, который должен быть выполнен
 * @param deps Массив зависимостей
 * @example
 * ```tsx
 * const Component = () => {
 *   const [width, setWidth] = useState(0);
 *   const ref = useRef<HTMLDivElement>(null);
 *
 *   useIsomorphicLayoutEffect(() => {
 *     if (ref.current) {
 *       setWidth(ref.current.offsetWidth);
 *     }
 *   }, []);
 *
 *   return (
 *     <div ref={ref}>
 *       Component width: {width}px
 *     </div>
 *   );
 * };
 *
 * // Использование для измерения DOM элементов
 * const MeasuredComponent = () => {
 *   const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
 *   const ref = useRef<HTMLDivElement>(null);
 *
 *   useIsomorphicLayoutEffect(() => {
 *     if (ref.current) {
 *       const rect = ref.current.getBoundingClientRect();
 *       setDimensions({
 *         width: rect.width,
 *         height: rect.height
 *       });
 *     }
 *   }, []);
 *
 *   return <div ref={ref}>Content</div>;
 * };
 * ```
 */
export const useIsomorphicLayoutEffect = typeof window === 'undefined' ? () => { } : useLayoutEffect;
